// extracted by mini-css-extract-plugin
export default {"draggableModal":"draggableModal__qSG8e6","backdrop":"backdrop__RVMUzJ","header":"header__F17bw0","headerTitle":"headerTitle__IvneHQ","closeIcon":"closeIcon__ifV3yT"};